import classNames from 'classnames'
import { t } from 'i18next'
import { SetStateAction, useContext } from 'react'
import childPlanFormDataContext from '../../../contexts/ChildPlanFormDataContext'
import parentFormDataContext from '../../../contexts/ParentFormDataContext'
import PaymentFormDataContext from '../../../contexts/PaymentFormDataContext'
import { PaymentFormDataObject } from '../../../contexts/contextDataObjects/PaymentFormDataObject'
import { formatCAD } from '../../../utils/currencyFormatHelper'
import ChildSummary from '../confirmation/ChildSummary'
export interface ISelectedPremiums {
    className?: string
    setShowConfirmation: React.Dispatch<SetStateAction<boolean>>
}
const SelectedPremiums: React.FC<ISelectedPremiums> = ({
    className,
    setShowConfirmation,
}) => {
    const { parentFormData, setParentFormData } = useContext(
        parentFormDataContext
    )
    const { paymentFormData, setPaymentFormData } = useContext(
        PaymentFormDataContext
    )
    const { childPlanFormData, setChildPlanFormData } = useContext(
        childPlanFormDataContext
    )
    // const childPremiums = childPlanFormData.map((child, index) => (
    //     <ChildSelectedPremiumsTable key={index} childPlan={child} className="pt-4" />
    // ))
    const childSummary = childPlanFormData.map((child, index) => (
        <ChildSummary key={index} childPlan={child} parentData={parentFormData} className="pt-4" />
    ))

    const totalCost = childPlanFormData.reduce((acc, cp) => {
        return acc + cp.Plan.Premium
    }, 0)

    const initialPaymentData =
        PaymentFormDataObject


    return (
        <div className='flex justify-center mt-7 '>
            <div
                className={classNames(
                    className,
                    'bg-[#0082ca] h-auto py-6 flex flex-col justify-center items-center lg:w-[55rem] md:w-[31rem] w-[20rem] shadow-md'
                )}
            >
                <h1 className="text-black pb-4 font-bold lg:text-xl text-lg">
                    {t('selectedPremiums')}
                </h1>
                <div className='bg-white shadow-md lg:w-[45rem] md:w-[28rem] w-[18rem] lg:overflow-x-hidden overflow-x-scroll '>
                    <table className='text-left md:text-base text-s'>
                        <thead className='border-b-2 border-gray-300'>
                            <tr className='py-2'>
                                <th className='text-black p-1 lg:w-[10rem] md:w-[9rem] w-[6rem]'>{t('name')}</th>
                                <th className='text-black p-1 lg:w-[10rem] md:w-[9rem] w-[6rem]'>{t('plan')}</th>
                                <th className='text-black p-1 lg:w-[10rem] md:w-[9rem] w-[6rem]'>{t('premium')}</th>
                                <th className='text-black p-1 lg:w-[10rem] md:w-[9rem] w-[6rem]'>{t('dob')}</th>
                                <th className='text-black p-1 lg:w-[10rem] md:w-[9rem] w-[6rem]'>{t('schoolBoard_1')}</th>
                                <th className='text-black p-1 lg:w-[10rem] md:w-[9rem] w-[6rem]'>{t('schoolName')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {/* {childPremiums} */}
                            {childSummary}
                        </tbody>

                    </table>
                </div>
                <h2 className="text-black font-bold lg:text-xl text-lg pt-5">
                    {t('totalCost')}
                </h2>
                <p className="text-black lg:text-xl text-base ">
                    <b>{formatCAD(totalCost, parentFormData.Language)}</b> {parentFormData.AutoEnroll.Renew == 'Yes' && (<b>{t('billedAnnually')}*</b>)}
                </p>

                {parentFormData.AutoEnroll.Renew === 'Yes' && (
                    <p className="text-black text-center text-base py-4 lg:w-[22rem] md:w-[18rem] w-[14rem] ">
                        *{t('autoEnrolloment')}.
                    </p>
                )}
            </div>
        </div >
    )
}

export default SelectedPremiums
